<template>
  <div class="card configurator-card">
    <div v-for="(page, i) in pages" v-bind:key="i">
      <div v-show="selectedPage === i + 1">
        <questions-component
            :pageCount="pages.length"
            :page="pages[i]"
            :step="i + 1"
            :availableProducts="availableProducts"
            v-on:changePage="changePage"
            v-on:validationstatus="updateValidationStatus"
            v-on:answers="(answers) => saveAnswers(i, answers)"
            v-on:updateProducts="updateProducts"
            ref="questionsComponent"
        >
        </questions-component>
      </div>
    </div>
    <!--    <div v-show="selectedPage === pages.length + 1 && !isSubmitted && !isSent">
          <contact-component
            :pageCount="pages.length"
            :step="pages.length + 1"
            v-on:contact="sendData"
            v-on:changePage="changePage"
          ></contact-component>
        </div>-->
    <div class="last-step" v-if="isSubmitted || isSent">
      <span v-if="isSubmitted">Sending ....</span>
      <div v-if="isSent">
        <h2 class="headline headline-4" v-if="isSent">{{ message }}</h2>
      </div>
    </div>
  </div>
</template>

<script>
import QuestionsComponent from "@/components/QuestionsComponent";

export default {
  name: "QuestionsPage",
  components: { QuestionsComponent },

  data() {
    const json = JSON.parse(
        document.querySelector("#configurator-app").dataset.json
    );
    return {
      pages: json.pages,
      products: json.products,
      selectedPage: 1,
      availableProducts: json.products,
      answers: [],
      contact: {},
      isSubmitted: false,
      isSent: false,
      message: "",
      validations: [],
    };
  },
  created() {
    this.pages.forEach(() => {
      this.answers.push([]);
      this.validations.push(false);
    });
  },
  methods: {
    changePage(page) {
      if (this.isAncestorsValid(page)) {
        // Save Changes to Localstorage
        let payload = {
          answers: this.answers,
          products: this.availableProducts,
        };
        /*
                this.answers.forEach(page => {
                  page = page[0];
                  if(page) {
                    payload.answers[page.questionsLabel] = page.header;
                  }
                })
        */
        this.$cookies.set("configurator_result", payload);
        this.selectedPage = page;
        this.scrollToCardTop();
      }
    },
    scrollToCardTop(){
      const card = document.querySelector(".configurator-card");
      card.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
    },
    isAncestorsValid(page) {
      if (page === 1) return true;
      const index = page - 1;
      for (let i = 0; i < index; i++) {
        if (!this.validations[i]) return false;
      }
      return true;
    },
    saveAnswers(i, answers) {
      this.answers[i] = answers;
    },
    updateProducts() {
      // Start with all products available
      let newProducts = this.products;
      if (this.answers.length > 0) {
        this.answers.forEach((page) => {
          page.forEach((answer) => {
            let newAnswerProduct = [];
            // Check if answer is present
            // We have an empty object for not yet answered questions on page
            if (typeof answer.products !== 'undefined' && answer.products.length) {
              answer.products.forEach((answerProduct) => {
                newProducts.forEach((product) => {
                  // Check if the product from the answer is in the products array
                  if (product.uid === answerProduct.uid) {
                    newAnswerProduct.push(product);
                  }
                });
              });
              // Set the products array to the filtered one
              newProducts = newAnswerProduct;
            }
          });
        });
        // Sort products by uid
        this.availableProducts = newProducts.sort((a,b) => a.uid - b.uid);
      } else {
        // If we don't have any answers, all products are available
        this.availableProducts = this.products;
      }
    },
    updateValidationStatus({ page, status }) {
      const index = page - 1;
      this.validations[index] = status;
    },
    sendData(contact) {
      const payload = {
        contact: contact,
        answers: this.answers,
        products: this.availableProducts,
      };
      var data = new FormData();
      data.append(
          "tx_pgwgolfconfigurator_configurator[input]",
          JSON.stringify(payload)
      );
      this.isSubmitted = true;
      const self = this;
      let url = document.location.href;
      url = url.split("?")[0];
      fetch(
          url +
          "?tx_pgwgolfconfigurator_configurator%5Baction%5D=send&tx_pgwgolfconfigurator_configurator%5Bcontroller%5D=Configurator",
          {
            method: "POST",
            body: data,
          }
      ).then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        self.isSubmitted = false;
        self.isSent = true;
        self.message = "Your request was successfully submitted";

        return response.body;
      });
    },
  },
};
</script>

<style scoped>
#configurator-app .row {
  margin-top: auto;
}
#configurator-app .headline {
  text-align: center;
}
#configurator-app .card {
  margin: 0 auto;
  background: #fff;
  border-radius: 15px;
  color: #20282b;
}
@media (min-width: 1200px) {
  #configurator-app .card {
    width: 80%;
    padding: 70px 90px;
  }
}
#configurator-app input {
  color: #20282b;
}
@media (max-width: 1199px) {
  #configurator-app .card {
    padding: 3rem 2rem;
    width: 100%;
  }
}
.last-step {
  text-align: center;
  margin: 200px 30px;
}
</style>
